"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const plugin_1 = require("@/plugin");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const mainData_1 = __importDefault(require("../seize/mainData"));
const mainData_2 = __importDefault(require("../execute/mainData"));
const complex_plugin_1 = require("complex-plugin");
const executeFlowConfig_1 = require("../execute/executeFlowConfig");
const seizeFlowConfig_1 = require("../seize/seizeFlowConfig");
exports.default = (0, vue_1.defineComponent)({
    name: 'FlowList',
    components: {
        ListView: ListView_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        unOperate: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            menu: {
                current: mainData_2.default,
                list: [
                    mainData_2.default,
                    mainData_1.default
                ]
            },
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: false,
                menu: {
                    list: [
                        {
                            prop: 'detail-emit',
                            name: '详情'
                        }
                    ]
                },
                info: {
                    modal: {
                        optionProps: {
                            width: 960
                        }
                    }
                },
                edit: {
                    modal: {
                        optionProps: {
                            width: 960
                        }
                    }
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        },
        operate() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        mainData() {
            return this.menu.current;
        }
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.loadData();
                }
            }
        }
    },
    beforeUnmount() {
        this.mainData.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        loadData() {
            this.mainData.$setExtra('litigationRecordId', this.id);
            this.mainData.$reloadData(true);
        },
        onBuild() {
            complex_plugin_1.notice.confirm('确认发起查封申请？', '确认', (act) => {
                if (act === 'ok') {
                    mainData_1.default.buildItem({});
                }
            });
        },
        onMenu(from, act, payload) {
            if (from === 'table') {
                if (act === 'detail-emit') {
                    if (this.menu.current === mainData_2.default) {
                        (0, executeFlowConfig_1.toExecuteInfo)(payload.record.id, payload.record.taskId, 'end');
                    }
                    else {
                        (0, seizeFlowConfig_1.toSeizeInfo)(payload.record.id, payload.record.taskId, 'end');
                    }
                }
            }
        }
    }
});
